module.exports = __webpack_public_path__ + "static/custom-print-photo-1-138895e4af4c9ff16f65821b2ca61649.jpg";